import * as React from 'react';
export const belfiusSvg = React.forwardRef(function belfiusSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M0 0h32v32H0z',
        fill: '#d60043',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M20.19 7a4.756 4.756 0 0 1 4.754 4.76v12.18c0 .554-.45 1.004-1.004 1.004H11.754A4.757 4.757 0 0 1 7 20.185V11.76A4.756 4.756 0 0 1 11.754 7zm-.932 7.753c1.009-.01 1.527-.466 1.52-1.315-.007-.849-.45-1.247-1.47-1.254a669.627 669.627 0 0 0-6.81 0c-.999.005-1.442.425-1.44 1.278.005.819.505 1.274 1.466 1.286 1.107.013 2.22.005 3.327.005h.005c1.13 0 2.268.01 3.402 0zm.085 5.024c.917-.013 1.396-.455 1.41-1.247.016-.836-.488-1.34-1.41-1.345-1.15-.005-2.298-.005-3.448-.005s-2.297 0-3.449.007c-.923.002-1.428.5-1.413 1.337.014.797.492 1.24 1.41 1.253 1.136.018 2.272.007 3.407.007h.004c1.163 0 2.33.009 3.49-.007z',
        fill: '#fff',
      }),
    ),
  );
});
belfiusSvg.defaultProps = {
  viewBox: '0 0 32 32',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var belfius = {
  category: 'brand',
  colorable: false,
  name: 'belfius',
  svg: belfiusSvg,
};
